'use strict';

module.exports = {
    /**
     * Updates the MemberPromotation flag, that indicates whether or not the promotion has been triggered.
     */
    updateMemberPromotionFlag: function(memberPromotionClass) {
            return;
    }
};